// extracted by mini-css-extract-plugin
module.exports = {"container":"Form_container__2iRJo","label":"Form_label__1LwvB","input":"Form_input__2qc2S","button":"Form_button__1k1zl"};